import { WardsService } from './wards.service'
import {
  FetchWardsRequest,
  FetchWardsSuccess,
  FetchWardsFailure,
  FetchWardRequest,
  FetchWardSuccess,
  FetchWardFailure,
  DeleteWardRequest,
  DeleteWardSuccess,
  DeleteWardFailure,
  CreateWardRequest,
  CreateWardSuccess,
  CreateWardFailure,
  UpdateWardRequest,
  UpdateWardSuccess,
  UpdateWardFailure,
} from './wards.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as Wards from './wards.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class WardsEffects {
  constructor(
    private actions: Actions,
    private wardsService: WardsService,
    private router: Router,
  ) {}

  FetchWards$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_WARDS_REQUEST),
      switchMap((action: FetchWardsRequest) => {
        return this.wardsService.fetchWards(action.payload).pipe(
          map((result) => {
            return new FetchWardsSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchWardsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchWard$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_WARD_REQUEST),
      switchMap((action: FetchWardRequest) => {
        return this.wardsService.fetchWard(action.id).pipe(
          map((result) => {
            return new FetchWardSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchWardFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteWard$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.DELETE_WARD_REQUEST),
      switchMap((action: DeleteWardRequest) => {
        return this.wardsService.deleteWard(action.id).pipe(
          switchMap(() => {
            return [new DeleteWardSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteWardFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateWard$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.CREATE_WARD_REQUEST),
      switchMap((action: CreateWardRequest) => {
        return this.wardsService.createWard(action.payload).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/wards'])
            return [new CreateWardSuccess()]
          }),
          catchError(() => {
            return of(new CreateWardFailure({}))
          }),
        )
      }),
    ),
  )

  UpdateWard$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.UPDATE_WARD_REQUEST),
      switchMap((action: UpdateWardRequest) => {
        return this.wardsService.updateWard(action.id, action.payload).pipe(
          switchMap(() => {
            this.router.navigate(['/admin/wards'])
            return [new UpdateWardSuccess()]
          }),
          catchError(() => {
            return of(new UpdateWardFailure({}))
          }),
        )
      }),
    ),
  )
}
